const swiperReview = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 'auto',
  spaceBetween: 12,
  centeredSlides: true,
  navigation: {
    nextEl: `.swiper-button-next-review`,
    prevEl: `.swiper-button-prev-review`,
    enabled: true,
  },
  breakpoints: {
    580: {
      slidesPerView: 2,
      centeredSlides: false,
    },
    980: {
      slidesPerView: 4,
      spaceBetween: 20,
      centeredSlides: false,
    },
  }
});